import React, { useEffect, useState } from "react";
import "./Telephone_mobile.css";

// --- IMPORT IMAGES ---
import s24fe from "./s24fe.png";
import s24 from "./s24.png";
import xcover7 from "./xcover7.png";
import pocox7pro from "./pocox7pro.png";
import redminote14pro from "./redminote14pro.png";
import redminote14proplus from "./redminote14proplus.png";
import xcover7pro from "./xconver7pro.png";
import xcover6pro from "./xconver6pro.png";
import s25 from "./s25.png";
import s25fe from "./s25fe.png";
import a06 from "./a06.png";
import a17 from "./a17.png";
import a36 from "./a36.png";
import a56 from "./a56.png";
import placeholder from "./placeholder.png";

// TABLEAU IMAGES
const imageMap = [
    { key: "S24 FE", img: s24fe },
    { key: "S24", img: s24 },
    { key: "S25 FE", img: s25fe },
    { key: "S25", img: s25 },

    { key: "Xcover 7 Pro", img: xcover7pro },
    { key: "Xcover 7", img: xcover7 },
    { key: "Xcover 6 Pro", img: xcover6pro },
    { key: "G736", img: xcover6pro },

    { key: "A06", img: a06 },
    { key: "A17", img: a17 },
    { key: "A36", img: a36 },
    { key: "A56", img: a56 },

    { key: "Poco X7 Pro", img: pocox7pro },
    { key: "Redmi Note 14 Pro Plus", img: redminote14proplus },
    { key: "Redmi Note 14 Pro", img: redminote14pro },
];

const findImage = (name) => {
    for (let item of imageMap) {
        if (name.toLowerCase().includes(item.key.toLowerCase())) return item.img;
    }
    return placeholder;
};

const Telephone_mobile = () => {
    const [rawPhones, setRawPhones] = useState([]);
    const [phones, setPhones] = useState([]);

    const [brandFilter, setBrandFilter] = useState("all");
    const [priceSort, setPriceSort] = useState("none");
    const [search, setSearch] = useState("");

    const [isBrandOpen, setIsBrandOpen] = useState(false);
    const [isPriceOpen, setIsPriceOpen] = useState(false);

    // Ferme les menus si on clique ailleurs
    useEffect(() => {
        const closeMenus = (e) => {
            if (!e.target.closest(".custom-select")) {
                setIsBrandOpen(false);
                setIsPriceOpen(false);
            }
        };
        document.addEventListener("click", closeMenus);
        return () => document.removeEventListener("click", closeMenus);
    }, []);

    // FETCH une seule fois
    useEffect(() => {
        fetch("https://amservices.eu/api/prix.php")
            .then((res) => res.json())
            .then((data) => {
                const grouped = {};

                data.forEach((p) => {
                    const prixHT = +(p.prix / 0.8).toFixed(2);
                    const prixTTC = +(prixHT * 1.2).toFixed(2);

                    if (!grouped[p.modele]) {
                        grouped[p.modele] = {
                            modele: p.modele,
                            image: findImage(p.modele),
                            variantes: [],
                            brand: p.modele.includes("Samsung") ? "Samsung" : "Xiaomi",
                        };
                    }

                    grouped[p.modele].variantes.push({
                        ram: p.ram,
                        stockage: p.stockage,
                        prixHT,
                        prixTTC
                    });
                });

                setRawPhones(Object.values(grouped));
            });
    }, []);

    // FILTRAGE à chaque changement
    useEffect(() => {
        let list = [...rawPhones];

        if (brandFilter !== "all") {
            list = list.filter((m) => m.brand === brandFilter);
        }

        if (search.trim() !== "") {
            list = list.filter((p) =>
                p.modele.toLowerCase().includes(search.toLowerCase())
            );
        }

        if (priceSort === "asc") {
            list.sort((a, b) => a.variantes[0].prixTTC - b.variantes[0].prixTTC);
        } else if (priceSort === "desc") {
            list.sort((a, b) => b.variantes[0].prixTTC - a.variantes[0].prixTTC);
        }

        setPhones(list);
    }, [rawPhones, brandFilter, priceSort, search]);

    return (
        <>
            <h2 className="section-title">Nos Portables</h2>

            <input
                type="text"
                className="search-bar"
                placeholder="Rechercher un modèle..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            <div className="filters">

                {/* FILTRE MARQUE */}
                <div className="custom-select">
                    <div className="custom-select-btn" onClick={() => setIsBrandOpen(!isBrandOpen)}>
                        {brandFilter === "all" ? "Toutes les marques" : brandFilter}
                    </div>
                    <div className={`custom-select-menu ${isBrandOpen ? "show" : ""}`}>
                        <div className="custom-option" onClick={() => setBrandFilter("all")}>Toutes les marques</div>
                        <div className="custom-option" onClick={() => setBrandFilter("Samsung")}>Samsung</div>
                        <div className="custom-option" onClick={() => setBrandFilter("Xiaomi")}>Xiaomi</div>
                    </div>
                </div>

                {/* TRI PRIX */}
                <div className="custom-select">
                    <div className="custom-select-btn" onClick={() => setIsPriceOpen(!isPriceOpen)}>
                        {priceSort === "asc" ? "Prix croissant" : priceSort === "desc" ? "Prix décroissant" : "Trier par prix"}
                    </div>
                    <div className={`custom-select-menu ${isPriceOpen ? "show" : ""}`}>
                        <div className="custom-option" onClick={() => setPriceSort("asc")}>Prix croissant</div>
                        <div className="custom-option" onClick={() => setPriceSort("desc")}>Prix décroissant</div>
                    </div>
                </div>

            </div>

            <div className="telephones-container">
                {phones.map((p, i) => (
                    <div key={i} className="phone-card">
                        <img src={p.image} alt={p.modele} />
                        <h3>{p.modele}</h3>

                        <div className="variant-list">
                            {p.variantes.map((v, idx) => (
                                <div key={idx} className="variant-line">
                                    <span>{v.ram}Go / {v.stockage}Go</span>
                                    <div className="price-block">
                                        <div className="price-line">HT : <strong>{v.prixHT} €</strong></div>
                                        <div className="price-line">TTC : <strong>{v.prixTTC} €</strong></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Telephone_mobile;
